module.exports = __webpack_public_path__ + "static/media/grafico_arrecadacao_03.bbc3180.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/grafico_arrecadacao_03.mp4
// module id = L7KJ
// module chunks = 0